import "./IconBox.css";

const IconBox = () => {
    return (
        <div className="icon-box">
            <a href="https://www.instagram.com/rish.singh7777/">
                <ion-icon name="logo-instagram"></ion-icon>
            </a>
            <a href="https://www.linkedin.com/in/rish-singh1/" target=" _blank" rel="noopener noreferrer">
                <ion-icon name="logo-linkedin"></ion-icon>
            </a>
            <a href="https://github.com/Rishabh-Singh-01/" target=" _blank" rel="noopener noreferrer">
                <ion-icon name="logo-github"></ion-icon>
            </a>
        </div >
    )
}

export default IconBox;